import { DOCUMENT } from '@angular/common';
import { DestroyRef, inject, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ImmersiveViewUiService {
    public readonly isFullscreen = signal(false);
    public readonly isPanelOpened = signal(false);

    private container: HTMLElement | null = null;
    private readonly destroyRef = inject(DestroyRef);
    private readonly document = inject(DOCUMENT);

    public constructor() {
        const onFullscreenChange = (): void => {
            this.isFullscreen.set(this.document.fullscreenElement === this.container);
        };

        this.document.addEventListener('fullscreenchange', onFullscreenChange);

        this.destroyRef.onDestroy(() => {
            this.document.removeEventListener('fullscreenchange', onFullscreenChange);
        });
    }

    public getContainer(): HTMLElement | null {
        if (!this.container) {
            return null;
        }

        return this.container;
    }

    public resetContainer(): void {
        this.container = null;
        this.isFullscreen.set(false);
    }

    public setContainer(element: HTMLElement): void {
        this.container = element;
        this.isFullscreen.set(this.document.fullscreenElement === element);
    }

    public async toggleFullscreen(): Promise<void> {
        if (!this.container) {
            return;
        }

        if (this.document.fullscreenElement === this.container) {
            await this.document.exitFullscreen();

            return;
        }

        await this.container.requestFullscreen();
    }
}
